import React, { memo } from "react";
import { filteredData } from "src/utils";
import { Box, Typography } from "@mui/material";
import { valueFormat } from "src/helper/valueFormat";
import { convertPaymentMethod } from "src/utils/paymentUtils";


export const collectTransactionsDto = (transactions) => {
  const filtered = filteredData(transactions);

  return filtered.map(item => {
    const retRef = item?.paymentInfo?.retRef || '';

    return {
      changed: item?.changed,
      amount: item?.tendered,
      tender: convertPaymentMethod(item?.tender?.method) || '',
      card_type: item?.paymentInfo?.cardType || '',
      account: item?.paymentInfo?.lastFour
        ? `XXXX XXXX XXXX ${item?.paymentInfo?.lastFour || ''}`
        : null,
      // capture: item?.paymentInfo?.capture || '',
      pin: item?.paymentInfo?.pin || '',
      authCode: item?.paymentInfo?.authCode || '',
      retRef: item?.paymentInfo?.retRef || retRef || '',
      // terminalId: item?.paymentInfo?.terminalId || '',
      // transactionId: item?.paymentInfo?.transactionId || '',
      aid: item?.paymentInfo?.aid || '',
      // card_reader: item?.paymentInfo?.card_reader || '',
      surchargeAmount: item?.surchargeAmount || 0
    };
  });
};

const OrderTransactions = ({ orderData }) => {
  const transactions = collectTransactionsDto(orderData?.metadata?.transactions);
  return (
    <>
      {transactions?.length > 0 && (
        <>
          <hr className="line-header" />
        </>
      )}
      {transactions?.map((transaction, index) => {
        return (
          <React.Fragment key={`tr-${index}`}>
            <Box className="payment-container">
              <Box style={{ width: "100%" }}>

                <Box style={{ marginBottom: '16px' }}>
                  <Box className="payment-container-flex">
                    <Typography className="payment-title uppercase">
                      Tender: {convertPaymentMethod(transaction?.tender)}
                    </Typography>
                    <Typography className="payment-title">
                      {valueFormat(`$${Number(transaction?.amount || 0).toFixed(2)}`)}
                    </Typography>
                  </Box>
                   {transaction?.surchargeAmount > 0 ? (
                      <Box className="payment-container-flex">
                        <Typography className="payment-title uppercase">
                          Surcharge:
                        </Typography>
                        <Typography className="payment-title">
                          {valueFormat(`$${Number(transaction?.surchargeAmount || 0).toFixed(2)}`)}
                        </Typography>
                      </Box>
                    ) : null}

                  {transaction?.changed ? (
                    <Box className="payment-container-flex">
                      <Typography className="payment-title uppercase">
                        Change:
                      </Typography>
                      <Typography className="payment-title">
                        {valueFormat(`$${Number(transaction?.changed || 0).toFixed(2)}`)}
                      </Typography>
                    </Box>
                  ) : null}
                </Box>

                {transaction?.card_type && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Card Type:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.card_type}
                    </Typography>
                  </Box>
                )}
                {transaction?.account && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Account:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.account}
                    </Typography>
                  </Box>
                )}
                {transaction?.capture && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Capture:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.capture}
                    </Typography>
                  </Box>
                )}

                {transaction?.pin && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Pin:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.pin}
                    </Typography>
                  </Box>
                )}
                {transaction?.authCode && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Auth code:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.authCode}
                    </Typography>
                  </Box>
                )}

                {transaction?.retRef && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Auth ref:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.retRef}
                    </Typography>
                  </Box>
                )}

                {transaction?.terminalId && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Terminal Id:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.terminalId}
                    </Typography>
                  </Box>
                )}

                {transaction?.transactionId && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Trans #:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.transactionId}
                    </Typography>
                  </Box>
                )}

                {transaction?.aid && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      aid:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.aid}
                    </Typography>
                  </Box>
                )}

                {transaction?.card_reader && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      card reader:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.card_reader}
                    </Typography>
                  </Box>
                )}

              </Box>
            </Box>
            <hr className="line-header" />
          </React.Fragment>
        )
      })}
    </>
  )
}
export default memo(OrderTransactions)